// src/pages/TimelinePage.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import Nav from '../components/Navbar.jsx';
import Footer from '../components/footer.jsx';
import Timeline from '../components/Timeline.jsx'; // Make sure this path is correct

const TimelinePage = () => {
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>My Journey | Andrew Snyder Design</title>
                <link rel="canonical" href="http://andrewsnyderdesign.com/timeline" />
            </Helmet>
            <Nav />
            <h1>My Journey</h1>
            <Timeline />
            <Footer />
        </div>
    );
};

export default TimelinePage;